import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import userReducer from 'store/user/userSlice';
import licenseReducer from 'store/license/licenseSlice';

export const store = configureStore({
  reducer: {
    user: userReducer,
    license: licenseReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
  devTools: process.env.NODE_ENV !== 'production',
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
